export default window.Report
